import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, map, Observable, of, switchMap } from 'rxjs';
import { EnvVarsService } from 'src/app/env-vars.service';

const mockData1: CousePlanningDanaosUparseResponse = {
  dt: {
    '0': '2022-02-02 12:00',
    '1': '2022-02-02 14:29',
    '2': '2022-02-02 16:51',
    '3': '2022-02-02 20:57',
    '4': '2022-02-03 00:24',
    '5': '2022-02-03 03:51',
    '6': '2022-02-03 06:52',
    '7': '2022-02-03 09:53',
    '8': '2022-02-03 12:54',
    '9': '2022-02-03 15:51',
    '10': '2022-02-03 18:48',
  },
  lat: {
    '0': 37.4,
    '1': 36.9,
    '2': 36.4,
    '3': 36.4,
    '4': 36.4,
    '5': 36.4,
    '6': 36.4,
    '7': 36.4,
    '8': 36.4,
    '9': 36.4,
    '10': 36.4,
  },
  lon: {
    '0': 23.708,
    '1': 23.708,
    '2': 23.708,
    '3': 22.52,
    '4': 21.52,
    '5': 20.52,
    '6': 19.52,
    '7': 18.52,
    '8': 17.52,
    '9': 16.52,
    '10': 15.52,
  },
  speed: {
    '0': 12.0,
    '1': 12.0,
    '2': 12.6,
    '3': 14.0,
    '4': 14.0,
    '5': 14.0,
    '6': 16.0,
    '7': 16.0,
    '8': 16.0,
    '9': 16.4,
    '10': 16.4,
  },
  ws: {
    '0': 28.22688,
    '1': 32.50368,
    '2': 30.07368,
    '3': 29.5488,
    '4': 10.36152,
    '5': 17.2044,
    '6': 18.79848,
    '7': 18.29304,
    '8': 11.62512,
    '9': 11.0808,
    '10': 12.90816,
  },
  wd: {
    '0': 8.72,
    '1': 6.61,
    '2': 13.43,
    '3': 10.1,
    '4': 52.47,
    '5': 12.62,
    '6': 355.26,
    '7': 347.57,
    '8': 336.05,
    '9': 243.44,
    '10': 236.92,
  },
  foc: {
    '0': 11.8532114029,
    '1': 11.1155424118,
    '2': -0.2632021606,
    '3': 19.7921485901,
    '4': -0.1635860205,
    '5': 94.2054214478,
    '6': 14.3784036636,
    '7': 95.8962173462,
    '8': 96.0980987549,
    '9': 94.1364059448,
    '10': 94.1364059448,
  },
};
const mockData2: CousePlanningDanaosUparseResponseMeta = {
  total_miles: 123,
  avg_speed: 3412,
  total_h: 2,
  total_foc: 45,
  total_emm: 1.893,
  cii: 443,
};
export interface ICalcPayload {
  fuel_type: number;
  dwt: number;
}
@Injectable({
  providedIn: 'root',
})
export class RouteOptimizationApiService {
  private API_URL = this.environment.getEnvKey('ROUTE_OPT_URL');
  private DANAOS_API_URL = this.environment.getEnvKey('DANAOS_MODEL_ROUTING');
  private url = `${this.API_URL}`;

  RouteModelConfig: Record<
    PlanningModels,
    {
      host: string;
      query: (...args: any[]) => Observable<TCoursePlanningResponse>;
    }
  > = {
    'Danaos Model': {
      host: `${this.DANAOS_API_URL}`,
      query: (vesselId: string, payload: TCoursePlanningDanaosPayload) => {
        // return of(mockData1).pipe(
        //   switchMap((response) => {
        //     return of(mockData2).pipe(
        //       map((data) => {
        //         return this.parseDanaosResponse(response, data);
        //       })
        //     );
        //   })
        // )

        const { model, ...rest } = payload;
        return this._http
          .post<CousePlanningDanaosUparseResponse>(
            `${this.DANAOS_API_URL}/routingDLL/`,
            payload
          )
          .pipe(
            switchMap((response) => {
              const payload2 = {
                emm_factor: payload.emm_factor,
                fuel_type: payload.fuel_type,
                dwt: payload.dwt,
                route: response,
              };
              console.log('Response from Route Optimization:', payload2);
              return this._http
                .post<CousePlanningDanaosUparseResponseMeta>(
                  `${this.DANAOS_API_URL}/calRoutingResp/`,
                  payload2
                )
                .pipe(
                  map((data) => {
                    return this.parseDanaosResponse(response, data);
                  })
                );
            })
          );
      },
    },
    'Konnecta Model': {
      host: this.API_URL,
      query: (vesselId: string, payload: TCoursePlanningKonnectaPayload) => {
        return this._http
          .post<TCoursePlanningKonnectaResponse>(
            `${this.url}/voyage-planner/${vesselId}`,
            payload
          )
          .pipe(map((data) => ({ ...data, model: 'Konnecta Model' })));
      },
    },
  };

  private messageSource = new BehaviorSubject<string>('');
  currentMessage = this.messageSource.asObservable();

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  constructor(
    private _http: HttpClient,
    private environment: EnvVarsService
  ) {}

  public RouteOptimization(
    vesselId: string,
    payload: TCoursePlanningPayload
  ): Observable<TCoursePlanningResponse> {
    console.log('RouteOptimization called with payload:', payload);
    const apiConfig = this.RouteModelConfig[payload.model];
    if (!apiConfig)
      throw new Error(`Route model ${payload.model} is not supported.`);

    return apiConfig.query(vesselId, payload);
  }

  private parseDanaosResponse(
    response: CousePlanningDanaosUparseResponse,
    data: CousePlanningDanaosUparseResponseMeta
  ): TCoursePlanningDanaosResponse {
    const vals: TCoursePlanningDanaosResponse = {
      model: 'Danaos Model',
      segments: Object.keys(response.lat).map((key) => [
        response.lat[key],
        response.lon[key],
      ]),
      dt: Object.values(response.dt).map((dt) =>
        moment(dt).format('YYYY-MM-DD HH:mm').valueOf()
      ),
      speed: Object.values(response.speed),
      ws: Object.values(response.ws),
      wd: Object.values(response.wd),
      foc: Object.values(response.foc),
      total_miles: data.total_miles,
      avg_speed: data.avg_speed,
      total_h: data.total_h,
      total_foc: data.total_foc,
      total_emm: data.total_emm,
      cii: data.cii,
    };
    console.log({ response, data, vals });
    return vals;
  }
}

export type Coordinates = [number, number];

export type TCoursePlanningResponse =
  | TCoursePlanningKonnectaResponse
  | TCoursePlanningDanaosResponse;

export type TCoursePlanningCommonsResponse = {
  model: PlanningModels;
  segments: Coordinates[];
  dt: (string | number)[];
  speed: number[];
  ws: number[];
  foc: number[];
};

export type TCoursePlanningKonnectaResponse = {
  model: 'Konnecta Model';
  summary: TSummary[];
} & TCoursePlanningCommonsResponse;

export type TCoursePlanningDanaosResponse = {
  model: 'Danaos Model';
  wd: number[];
} & CousePlanningDanaosUparseResponseMeta &
  TCoursePlanningCommonsResponse;

export type CousePlanningDanaosUparseResponse = {
  lat: { [key: string]: number };
  lon: { [key: string]: number };
  dt: { [key: string]: string };
  ws: { [key: string]: number };
  speed: { [key: string]: number };
  wd: { [key: string]: number };
  foc: { [key: string]: number };
};
export type CousePlanningDanaosUparseResponseMeta = {
  total_miles: number;
  avg_speed: number;
  total_h: number;
  total_foc: number;
  total_emm: number;
  cii: number;
};

export const RouteModels = ['Danaos Model', 'Konnecta Model'] as const;

export type PlanningModels = (typeof RouteModels)[number];

export type TCoursePlanningCommon = {
  model: PlanningModels;
};

export type TCoursePlanningPayload =
  | TCoursePlanningKonnectaPayload
  | TCoursePlanningDanaosPayload;

export type TCoursePlanningKonnectaPayload = TCoursePlanningCommon & {
  model: 'Konnecta Model';
  route: Coordinates[];
  starttime?: number;
  UserSpeedReference: 'id';
  FuelType: TCoursePlanningPayloadFuelType;
  weather: TCoursePlanningPayloadWeather;
  speed?: number;
  duration_h?: number;
  loading?: TCoursePlanningPayloadLoading;
  reference: TCoursePlanningPayloadReference;
  draft?: number;
};

export type TCoursePlanningDanaosPayload = TCoursePlanningCommon & {
  model: 'Danaos Model';
  start: [number, number];
  end: [number, number];
  ctrlpoints: Coordinates[] | null;
  minSpeed: number;
  maxSpeed: number;
  weather: boolean;
  departDT: string; // ISO 8601 format
  transat: boolean;
  from: null;
  to: null;
  codeFrom: null;
  codeTo: null;
  emm_factor: any;
  fuel_type: any;
  dwt: any;
};

export type TCoursePlanningPayloadWeather =
  | 'as in reference'
  | 'actual'
  | 'BF4'
  | 'BF5'
  | 'BF6';

export type TCoursePlanningPayloadFuelType = 1 | 2 | 3 | 4 | 5 | 6;

export type TCoursePlanningPayloadLoading = 0 | 1 | 2 | 3 | 4 | 5;

export type TCoursePlanningPayloadReference =
  | 'EstablishedSpeedRef'
  | 'SeaTrials'
  | 'UserSpeedReferences';

export type TSummary =
  | ['total_dist', number]
  | ['constrain_type', string]
  | ['speed', number]
  | ['duration', number]
  | ['power', number]
  | ['bsfc', number]
  | ['total_fuel', number];
